module.exports = __webpack_public_path__ + "static/media/11_FVCON_Cyroth.204e82ab.png";